import { useCallback, useState } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { StyledLabel } from './PropertyLabel';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TruncatedPropertyLabel({
  labelStr,
  propertyName,
  renderLabel,
  labelStyles
}) {
  const [isTruncated, setIsTruncated] = useState(false);
  const handleMouseEnter = useCallback(({
    currentTarget
  }) => {
    setIsTruncated(currentTarget.scrollWidth > currentTarget.clientWidth);
  }, []);
  const TooltipContent = useCallback(() => /*#__PURE__*/_jsxs(_Fragment, {
    children: [" ", renderLabel ? renderLabel() : labelStr]
  }), [labelStr, renderLabel]);
  return /*#__PURE__*/_jsx(Tooltip, {
    Content: TooltipContent,
    maxInlineSize: "500px",
    disabled: !isTruncated,
    children: /*#__PURE__*/_jsx(StyledLabel, {
      onMouseEnter: handleMouseEnter,
      truncate: true,
      "data-test-id": "property-label",
      "data-test-property-name": propertyName,
      labelStyles: labelStyles,
      children: renderLabel ? renderLabel() : labelStr
    })
  });
}